<template>
<div>
    <h1>Tarieven</h1>
    <div class="alert alert-info" role="alert">
        <span>Om extreme bodem tarieven te voorkomen hanteren wij een minimum van € 12,50 per uur exclusief BTW. Daarnaast brengt Azurity 10% in rekening voor haar dienstverlening, marketing en onderhoud van het platform. </span>
    </div>
    <div class="form-group form-row">
        <label class="form-label col-md-8">Standaard Uurtarief (07:00 - 18:00)</label>
        <div class="input-group col-md-4">
            <div class="input-group-prepend">
                <div class="input-group-text">€</div>
            </div>
            <input min="15" type="number" :class="['form-control bg-light', ($v.profile.dayRate.$dirty) ? ($v.profile.dayRate.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="15" v-model="profile.dayRate" />
            <span class="invalid-feedback">Het minimum tarief is € 12,50. Hiermee voldoen we minimaal aan hetgeen in de CAO staat.</span>
            <span class="valid-feedback">U ontvangt € <span>{{(profile.dayRate * 0.9).toFixed(2)}}</span> per uur (excl. BTW indien van toepassing).</span>
        </div>
    </div>
    <div class="form-group form-row">    
        <label class="form-label col-md-8">Standaard Avond Uurtarief (18:00 - 24:00)</label>
        <div class="input-group col-md-4">
            <div class="input-group-prepend">
                <div class="input-group-text">€</div>
            </div>
            <input :min="minEveningRate" type="number" :class="['form-control bg-light', ($v.profile.eveningRate.$dirty) ? ($v.profile.eveningRate.$error) ?'is-invalid' : 'is-valid' : '']" :placeholder="minEveningRate" v-model="profile.eveningRate" />
            <span class="invalid-feedback">Dient minimaal 110% van het standaard uurtarief te zijn.</span>
            <span class="valid-feedback">U ontvangt € <span>{{(profile.eveningRate * 0.9).toFixed(2)}}</span> per uur (excl. BTW indien van toepassing).</span>
        </div>
    </div>
    <div class="form-group form-row">
        <label class="form-label col-md-8">Standaard Nacht Uurtarief (24:00 - 07:00)</label>
        <div class="input-group col-md-4">
            <div class="input-group-prepend">
                <div class="input-group-text">€</div>
            </div>
            <input :min="minNightRate" type="number" :class="['form-control bg-light', ($v.profile.nightRate.$dirty) ? ($v.profile.nightRate.$error) ?'is-invalid' : 'is-valid' : '']" :placeholder="minNightRate" v-model="profile.nightRate" />
            <span class="invalid-feedback">Dient minimaal 120% van het standaard tarief te zijn.</span>
            <span class="valid-feedback">U ontvangt € <span>{{(profile.nightRate * 0.9).toFixed(2)}}</span> per uur (excl. BTW indien van toepassing).</span>
        </div>
    </div>
    <div class="form-group form-row">
        <label class="form-label col-md-8">Standaard Weekend Uurtarief (zaterdag & zondag)</label>
        <div class="input-group col-md-4">
            <div class="input-group-prepend">
                <div class="input-group-text">€</div>
            </div>
            <input :min="minWeekendRate" type="number" :class="['form-control bg-light', ($v.profile.weekendRate.$dirty) ? ($v.profile.weekendRate.$error) ?'is-invalid' : 'is-valid' : '']" :placeholder="minWeekendRate" v-model="profile.weekendRate" />
            <span class="invalid-feedback">Dient minimaal 135% van het standaard tarief te zijn.</span>
            <span class="valid-feedback">U ontvangt € <span>{{(profile.weekendRate * 0.9).toFixed(2)}}</span> per uur (excl. BTW indien van toepassing).</span>
        </div>
    </div>
    <div class="form-group form-row">
        <label class="form-label col-md-8">Standaard Hond Toeslag</label>
        <div class="input-group col-md-4">
            <div class="input-group-prepend">
                <div class="input-group-text">€</div>
            </div>
            <input min="0" type="number" :class="['form-control bg-light', ($v.profile.dogRate.$dirty) ? ($v.profile.dogRate.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="0" v-model="profile.dogRate" />
        
            <span class="invalid-feedback">Deze toeslag wordt per uur toegevoegd aan uw standaard tarief.</span>
            <span class="valid-feedback">U ontvangt € <span>{{(profile.dogRate * 0.9).toFixed(2)}}</span> per uur toeslag (excl. BTW indien van toepassing).</span>
        </div>
    </div>
    <div class="form-group text-right">
        <button class="btn btn-outline-azure" @click="save" type="button" >Opslaan</button>
    </div>
</div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, numeric, minValue } from 'vuelidate/lib/validators'

export default {
    props: ['user'],
    mixins: [validationMixin],
    componets: {
    },
    data() {
        return {
        }
    },
    validations: {
        profile: {
            dayRate: {
                required,
                minValue: minValue(12.5)
            },
            eveningRate: {
                required,
                minValue: minValue(12.5)
            },
            nightRate: {
                required,
                minValue: minValue(12.5)
            },
            weekendRate: {
                required,
                minValue: minValue(12.5)
            },
            dogRate: {
                minValue: minValue(0)
            }
        }
    },
    methods: {
        save() {
            this.$v.profile.$touch();
            if(!this.$v.profile.$invalid)
            {
                this.$emit('loading', true);
                let self = this;
                this.$http.post('api/User/SaveProfessionalRates', { 
                    dayRate: this.profile.dayRate,
                    eveningRate: this.profile.eveningRate,
                    nightRate: this.profile.nightRate,
                    weekendRate: this.profile.weekendRate,
                    dogRate: this.profile.dogRate
                }).then(() => {
                    this.$emit('loading', false);
                }).catch(() => 
                {
                    alert('Whoops, er is iets fout gegaan. Probeer nogmaals.')
                    self.$emit('loading', false);
                })
            }
        }
    },
    watch: {
        'profile.dayRate'() {
                if(this.profile.eveningRate < this.profile.dayRate * 1.1)
                    this.profile.eveningRate = this.profile.dayRate * 1.1;
                if(this.profile.nightRate < this.profile.dayRate * 1.2)
                    this.profile.nightRate = this.profile.dayRate * 1.2;
        }
    },
    computed: {
        minEveningRate() {
            return this.profile.dayRate * 1.1
        },
        minNightRate() {
            return this.profile.dayRate * 1.2
        },
        minWeekendRate() {
            return this.profile.dayRate * 1.35
        },
        profile() {
            if(this.user)
                return this.user.professionalProfile;
            return {};
        },
    }
}
</script>

<style scoped>
img {
    opacity: 0.5
}
img:hover {
    opacity: 1;
}
label {
    display: inline-block !important;
}
</style>

